import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const RaceMetaDataEwTerms = withConfig(theme => styled('div', { label: 'RaceMetaDataEwTerms' })`
    display: flex;
    font-size: ${theme.star.fontSize.small};
    gap: 4px;
    line-height: 1.3334;
`);

export const RaceMetaDataEwTermsItem = styled('i', { label: 'RaceMetaDataEwTermsItem' })`
    font-style: normal;
`;
